
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm1.527 17.5H15.5v-.003h-.013V7h-2.852C9.772 7 8.26 8.373 8.26 10.392c0 1.615.83 2.572 2.306 3.553L8 17.498h2.12l2.852-3.98-.992-.622c-1.204-.75-1.786-1.337-1.786-2.607 0-1.118.844-1.868 2.455-1.868h.879V17.5z","fill":"currentColor"}})])
          )
        }
      }
    